import creator from './creator';
// import storage from '../core/storage';
import {
  FETCH_USER_STATUS,
  FETCH_USER_REMIND,
  CANCEL_USER_REMIND,
  BIND_MOBILE,
  // LOG_OUT,
 } from '../constants';


// 用户信息
export const fetchStatus = creator(FETCH_USER_STATUS, 'data')
export function statusFetch() {
  return async function statusFetchAction(dispatch, getState, { ds }) {
    const resp = await ds.userStatus()
    const data = await resp.json()
    if (data.error) return
    dispatch(fetchStatus(data))
  }
}

// 用户提醒
export const fetchRemind = creator(FETCH_USER_REMIND, 'data')
export function remindFetch() {
  return async function remindFetchAction(dispatch, getState, { ds }) {
    const resp = await ds.userRemind()
    const data = await resp.json()
    if (!data.result) return
    dispatch(fetchRemind(data))
  }
}

// 不再提醒
export const cancelRemind = creator(CANCEL_USER_REMIND, 'inx')
export function cancelUserRemind(inx) {
  return async function stopRemindAction(dispatch, getState, { ds }) {
    await ds.cancelRemind(getState().user.remind[inx].hash)
    dispatch(cancelRemind(inx))
  }
}

// 退出登录
// export const logOutCurUser = creator(LOG_OUT)
export function loginOut(backUrl) {
  return async function logoutAction(dispatch, getState, { ds }) {
    try {
      const result = await ds.loginOut(backUrl)
      const data = await result.json()

      if (data.code === 0) {
        // dispatch(logOutCurUser())
        // 需要同时清空用户状态和登陆状态, 直接刷新当前页面
        return true
      }

      return false
    } catch (err) {
      console.error('loginOut-error', err)
      return false
    }
  }
}

// 绑定相关
// 绑定手机号和主账号
export const bindMobileEnd = creator(BIND_MOBILE, 'data')
export function bindMobile() {
  return async function bindMobileAction(dispatch, getState, { ds }) {
    try {
      const resp = await ds.bindMobile()
      const data = await resp.json()
      dispatch(bindMobileEnd(data))
    } catch (error) {
      console.error('绑定手机号异常，请稍后再试', error) // eslint-disable-line no-console
    }
  }
}

// 强制绑定手机
export function forceBindMobile() {
  return async function forceBindMobileAction(dispatch, getState, { ds }) {
    try {
      const resp = await ds.forceBindMobile()
      const data = await resp.json()

      return data
      // dispatch(bindMobileEnd(data))
    } catch (error) {
      console.error('强制绑定手机号异常，请稍后再试', error) // eslint-disable-line no-console
      return {}
    }
  }
}

// 更新绑定手机
export function updateBindMobile() {
  return async function updateBindMobileAction(dispatch, getState, { ds }) {
    try {
      const resp = await ds.updateBindMobile()
      const data = await resp.json()
      return data
      // dispatch(bindMobileEnd(data))
    } catch (error) {
      console.error('更新绑定手机号异常，请稍后再试', error) // eslint-disable-line no-console
      return {}
    }
  }
}
// 解绑手机号和主账号, 未使用
// export const unbindMobileEnd = creator(UNBIND_MOBILE, 'data')
export function unbindMobile() {
  return async function unbindMobileAction(dispatch, getState, { ds }) {
    try {
      const resp = await ds.unbindMobile()
      const data = await resp.json()
      return data
      // dispatch(unbindMobileEnd(data))
    } catch (error) {
      console.error('解绑手机号异常，请稍后再试', error) // eslint-disable-line no-console
      return {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js